import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { format } from "helpers/time/format";
import { IEvent } from "modules/event/types";
import { useI18n } from "i18n";
import { useStyles } from "./styles";

interface IEventOptionProps {
  option: IEvent;
}

/**
 * Reusable component for rendering events as options for MUI autocomplete
 * TODO Consider allowing date format customization as prop
 */
const EventListOption = ({ option, ...props }: IEventOptionProps) => {
  const { t } = useI18n(["common"]);
  const styles = useStyles();

  return (
    <Container flex justifyContent="flex-start" {...props}>
      <img
        src={option.logoURL}
        alt={option.name}
        className={styles.optionImage}
      />
      <Container>
        <Typography variant="h5" color="textPrimary">
          {option.name}
          {option.isPrivate && (
            <span className={styles.privateEventOption}>
              {t("common:private")}
            </span>
          )}
        </Typography>
        <Typography variant="h6" color="textPrimary">
          {`${format(option.startTime, "h:mm a MMM DD")}`} -{" "}
          {`${format(option.endTime, "h:mm a MMM DD YYYY")}`}
        </Typography>
      </Container>
    </Container>
  );
};

export default EventListOption;
